import { connect } from 'react-redux';
import { compose } from 'redux';
import { withDesktopBreakpoint } from '@Hooks/withBreakpoints/withBreakpoint';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { setCurrentEditor as setCurrentEditorAction, setStructure as setStructureAction } from './actions';
import StructureEditorPageComponent from './StructureEditorPageComponent';

const mapDispatchToProps = (dispatch) => ({
  setCurrentEditor: (editor) => dispatch(setCurrentEditorAction(editor)),
  setStructureToEditor: (newStructure) => dispatch(setStructureAction(newStructure)),
});

export default compose(
  withCombinedRouteParams,
  connect(() => ({}), mapDispatchToProps),
  withDesktopBreakpoint()
)(StructureEditorPageComponent);
